import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "./NavigationBar.css"; // Custom CSS for styling

const NavigationBar = ({ activeButton, setActiveButton }) => {

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber);
  };

  return (
    <div className="container d-flex justify-content-center text-center mt-5">
      <div>
        <button
          className={`navbar-btn ${activeButton === 1 ? "active" : ""}`}
          onClick={() => handleButtonClick(1)}
        >
          Account Information
        </button>
        <button
          className={`navbar-btn ${activeButton === 2 ? "active" : ""}`}
          onClick={() => handleButtonClick(2)}
        >
          Change Password
        </button>
        <button
          className={`navbar-btn ${activeButton === 3 ? "active" : ""}`}
          onClick={() => handleButtonClick(3)}
        >
          Notification Settings
        </button>
      </div>
    </div>
  );
};

export default NavigationBar;
